import React, { createContext, useState, useContext } from 'react';
import { searchProducts } from '../services/kollectaHealthCore';

const PatientContext = createContext();

export const PatientProvider = ({ children }) => {
  const [patientData, setPatientData] = useState({});

  const updatePatient = (newData) => {
    setPatientData(newData);
  };

  const addTreatment = (newTreatment) => {
    setPatientData(prevData => ({
        ...prevData,
        treatments: [...prevData.treatments, newTreatment]
    }));
  };

  const refreshPatientData = async () => {
    try {
      if (!patientData?.customer?.personalNumber || !patientData?.type) {
        console.error('PatientContext - Dados insuficientes para refresh:', {
          personalNumber: patientData?.customer?.personalNumber,
          type: patientData?.type
        });
        throw new Error('Dados insuficientes para buscar paciente');
      }

      console.log('PatientContext - Refreshing patient data for:', {
        personalNumber: patientData.customer.personalNumber,
        type: patientData.type
      });

      const searchResponse = await searchProducts({
        customerName: '',
        personalNumber: patientData.customer.personalNumber,
        studyNumber: '',
        type: patientData.type
      });

      console.log('PatientContext - Search response:', searchResponse);

      const products = searchResponse?.data?.products || searchResponse?.products;
      if (products && products.length > 0) {
        const updatedData = products[0];
        const newPatientData = { ...updatedData };
        if (updatedData.treatments) {
          newPatientData.treatments = updatedData.treatments.map(treatment => {
            const newTreatment = { ...treatment };
            if (treatment.treatmentMedications) {
              newTreatment.treatmentMedications = treatment.treatmentMedications.map(med => ({ ...med }));
            }
            return newTreatment;
          });
        }
        if (updatedData.customer) {
          newPatientData.customer = { ...updatedData.customer };
        }
        setPatientData(newPatientData);
        return newPatientData;
      } else {
        throw new Error('Paciente não encontrado');
      }
    } catch (error) {
      console.error('PatientContext - Error refreshing patient data:', error);
      throw error;
    }
  };

  return (
    <PatientContext.Provider value={{ patientData, updatePatient, addTreatment, refreshPatientData }}>
      {children}
    </PatientContext.Provider>
  );
};

export const usePatient = () => useContext(PatientContext);
